/**
 * Skill names are snake_case identifiers (e.g. `generate_working_letter_v2`); everywhere a person
 * reads one it is shown in sentence case ("Generate working letter v2").
 */
export function formatSkillName(name: string): string {
  const words = name.split('_').filter(Boolean);
  if (words.length === 0) return name;
  const [first, ...rest] = words;
  return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
}

export function skillLabel(skill: { name: string; label?: string | null }): string {
  return skill.label || formatSkillName(skill.name);
}
